import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import ReportNameCreateForm from './ReportNameCreateForm';

const styles = () => ({
  form: {
    padding: '35px 100px',
  },
});

const ReportNameCreateDialog = ({
  open,
  onClose,
  title,
  onSubmitSuccess,
  actions,
  submitting,
  form,
  initialValues,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent>
      <ReportNameCreateForm
        className={classes.form}
        form={form}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
        initialValues={initialValues}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);

ReportNameCreateDialog.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({
    Name: PropTypes.string,
  }),
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

ReportNameCreateDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  initialValues: null,
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReportNameCreateDialog),
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportNameCreateDialog/ReportNameCreateDialog.js